import { SchemaField } from '../../../generic/serialization/schema-field';
import { SerializableObjectSchema } from '../../../generic/serialization/serializable-object-schema';
import { CallerIdStrategyType } from '../../caller-id-strategy/caller-id-strategy-type';

export class ReservationOfferChannelConfigPhoneCallSchema extends SerializableObjectSchema {
  public static readonly callerIdObjId = 'callerIdObjId';

  public static readonly callerIdStrategyType = 'callerIdStrategyType';

  public static readonly dialTimeoutMS = 'dialTimeoutMS';

  public static readonly vrcAudioMetadataId = 'vrcAudioMetadataId';

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Constants
  ////////////////////////////////////////////////////////////////////////////////////////////////

  static Defaults = class {
    public static readonly callerIdObjId = undefined;

    public static readonly callerIdStrategyType = undefined;

    public static readonly dialTimeoutMS = undefined;

    public static readonly vrcAudioMetadataId = undefined;
  };

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Schema Parameters
  ////////////////////////////////////////////////////////////////////////////////////////////////

  // prettier-ignore
  public getSchemaDefinition(): {[key: string]: import('joi').AnySchema} {
    const parameters = { } as any;

    /* eslint-disable */
    parameters[ReservationOfferChannelConfigPhoneCallSchema.dialTimeoutMS] = SchemaField.number(undefined).required()
    // @Todo: make callerIdObjId required. Need to investigate UI to ensure that it's not possible to save this object without a callerIdObjId
    parameters[ReservationOfferChannelConfigPhoneCallSchema.callerIdObjId] = SchemaField.autoGeneratedDocId(undefined, ReservationOfferChannelConfigPhoneCallSchema.Defaults.callerIdObjId).optional()
    parameters[ReservationOfferChannelConfigPhoneCallSchema.vrcAudioMetadataId] = SchemaField.autoGeneratedDocId(undefined, ReservationOfferChannelConfigPhoneCallSchema.Defaults.vrcAudioMetadataId).required()
    parameters[ReservationOfferChannelConfigPhoneCallSchema.callerIdStrategyType] = SchemaField.string(undefined)
      .optional()
      .valid(...Object.values(CallerIdStrategyType));
    /* eslint-enable */

    return parameters;
  }
}
